import { animate, style, transition, trigger } from '@angular/animations';
import { Component, OnInit, Renderer2 } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { DeliveryWindowComponent } from 'src/@order/components/bottom-sheets/delivery-window/delivery-window.component';
import { PendingFeedbackComponent } from 'src/@order/components/bottom-sheets/pending-feedback/pending-feedback.component';
import { AllDiscountListDialogComponent } from 'src/@order/dialogs/all-discount-list-dialog/all-discount-list-dialog.component';
import { WalletInfoDialogComponent } from 'src/@order/dialogs/wallet-info-dialog/wallet-info-dialog.component';
import { AuthServiceLocal } from 'src/@order/services/auth.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  animations: [
    trigger('showHideUp', [
      transition(':enter', [
        style({ transform: 'translateY(20px)', opacity: 0 }),
        animate(200, style({ transform: 'translateY(0px)', opacity: 1 })),
      ]),
      transition(':leave', [
        animate(200, style({ transform: 'translateY(20px)', opacity: 0 })),
      ]),
    ]),
  ],
})
export class HomeComponent implements OnInit {
  isDeliveryWindowClose: boolean = false;
  isDeliveryWindowBannerShowing: boolean = false;
  windowTime;
  discountSlotList: [] = [];
  isDiscountBannerShowing: boolean = false;
  userName = JSON.parse(localStorage.getItem('authUser')).firstName;
  greetings: string;
  country = localStorage.getItem('country');

  // localData = JSON.parse(localStorage.getItem('PWAToken'));

  getInterRegionalRoute(): string {
    return this.country === 'Ghana' ? '/inter-regional' : '/inter-state';
  }

  constructor(
    public _auth: AuthServiceLocal,
    private _matdialog: MatDialog,
    private renderer: Renderer2,
    private _router: Router,
    private _bottomSheet: MatBottomSheet,
    private _matDialog: MatDialog
  ) {
    this.setGreetings();
    // this.addGoogleTag();
  }

  // addGoogleTag() {

  //   const item = {
  //     'item_id': '654879',
  //     'item_name': 'egg',
  //     'affiliation': "phlenu",
  //     'coupon': '',
  //     'discount': '20',
  //     'index': 1,
  //     'item_brand': "Google",
  //     'item_category': 'pharmacy',
  //     'price': '1200',
  //     'quantity': '1'
  //   };

  //   // Adding data to the GTM Data Layer
  //   window.dataLayer = window.dataLayer || [];
  //   window.dataLayer.push({
  //     'event': 'purchase',
  //     'email': 'jagdishseervi@gts.com',
  //     'phone': 'phone',
  //     'ecommerce': {
  //       'transaction_id': '123456',
  //       'value': '514',
  //       'tax': '10',
  //       'shipping': '',
  //       'currency': 'GHS',
  //       'price': '2100',
  //       'coupon': '',
  //       'items': [item]
  //     }
  //   });

  //   // Dynamically add the event snippet to the page
  //   const purchaseEventScript = this.renderer.createElement('script');
  //   purchaseEventScript.text = `
  //     gtag('event', 'purchase', {
  //       'send_to': 'GTM-PLHCG6G7/odOBCO3-1_UBEKfOyeIB',
  //       'email': 'jagdishseervi@gtsinfo.com',
  //       'phone': '987456874',
  //       'ecommerce': {
  //         'transaction_id': '123456',
  //         'value': '514',
  //         'tax': '10',
  //         'shipping': '',
  //         'currency': 'GHS',
  //         'price': '2100',
  //         'coupon': '',
  //         'items': ${JSON.stringify(item)}
  //       }
  //     });
  //   `;
  //   this.renderer.appendChild(document.head, purchaseEventScript);
  // }

  ngOnInit(): void {
    this._auth.getDashboardData({});
    this.getDeliveryWindowsUpdate();
    this.getPdasDiscountList();
    this.getWebDestinationsData();

    // check feedback data
    // this.getFeedbackData();

    console.log('this._auth.walletAmount', this._auth.walletAmount);
  }

  setGreetings() {
    const myDate = new Date();
    const hrs = myDate.getHours();
    if (hrs < 12) {
      this.greetings = 'Good Morning';
    } else if (hrs >= 12 && hrs <= 17) {
      this.greetings = 'Good Afternoon';
    } else if (hrs >= 17 && hrs <= 24) {
      this.greetings = 'Good Evening';
    }
  }

  getDeliveryWindowsUpdate() {
    this._auth.getDeliveryWindowUpdate().subscribe((res: any) => {
      if (res.response === 1) {
        if (res?.data?.isBusinessPartner == 1) {
          localStorage.setItem(
            'isBusinessPartner',
            res?.data?.isBusinessPartner
          );
        } else {
          localStorage.setItem('isBusinessPartner', '0');
        }

        this.isDeliveryWindowClose =
          res?.data?.time?.isOpen !== 1 ? true : false;
        this.windowTime = res?.data?.time;

        if (this.isDeliveryWindowClose) {
          this.isDeliveryWindowBannerShowing = true;

          this._bottomSheet
            .open(DeliveryWindowComponent, {
              panelClass: ['full-width-bottom-sheet'],
              backdropClass: 'no-overlay-backdrop',
              disableClose: false,
              data: this.windowTime,
            })
            .afterDismissed()
            .subscribe(() => {
              // Now open the second one (feedback) *after* the delivery window is dismissed
              this.getFeedbackData();
            });
        } else {
          // if delivery window is not closed, we can check feedback right away
          this.getFeedbackData();
        }
      } else {
        this.isDeliveryWindowClose = false;
        this.getFeedbackData(); // fallback call
      }
    });
  }

  onCloseDeliveryWindow() {
    this.isDeliveryWindowBannerShowing = false;
  }

  dialogOpen() {
    if (localStorage.getItem('isWalletWelcomeShow') == '0') {
      const dialog = this._matDialog.open(WalletInfoDialogComponent, {
        panelClass: ['commonDialogWrapper'],
        backdropClass: 'dialogBackdrop',
        width: '580px',
      });
      dialog.afterClosed().subscribe((res) => {
        localStorage.setItem('isWalletWelcomeShow', '1');
      });
    } else {
      this._router.navigate(['/wallet-transaction']);
    }
  }

  getPdasDiscountList() {
    console.log('res in discount list');
    this._auth.getPdasDiscountList().subscribe((res: any) => {

      if (res.response) {
        this.discountSlotList = res.data.discounts;
        if (this.discountSlotList.length) this.isDiscountBannerShowing = true;
      } else {
        this.discountSlotList = [];
      }
    });
  }

  getWebDestinationsData() {
    const countryName = localStorage.getItem('country');
    this._auth
      .getWebDestinations({ country: countryName })
      .subscribe((res: any) => {
        localStorage.setItem('webDestinations', JSON.stringify(res.data));
      });
  }

  public showAllDiscount() {
    const dialog = this._matdialog.open(AllDiscountListDialogComponent, {
      panelClass: ['commonDialogWrapper'],
      backdropClass: 'dialogBackdrop',
      disableClose: false,
      autoFocus: false,
      width: '610px',
      data: {
        discountList: this.discountSlotList,
      },
    });

    dialog.afterClosed().subscribe(() => {
      this.isDiscountBannerShowing = false;
    });
  }

  getFeedbackData() {
    this._auth.getPendingFeedbacks().subscribe((res: any) => {
      if (res.data.completedOrders?.length) {
        this.openSaverBottomSheet(res.data.completedOrders?.length);
      }
    });
  }

  openSaverBottomSheet(data) {
    this._bottomSheet
      .open(PendingFeedbackComponent, {
        panelClass: ['bottomSheetWrapper'],
        disableClose: false,
        data: data,
      })
      .afterDismissed()
      .subscribe(() => {
        // this.isSaverPlanBottomSheetShow = true;
        // this.saveDataInfoLocal();
      });
  }

  openDeliveryWindow() {
    this._bottomSheet
      .open(DeliveryWindowComponent, {
        panelClass: ['full-width-bottom-sheet'],
        backdropClass: 'no-overlay-backdrop',
        disableClose: false,
      })
      .afterDismissed()
      .subscribe(() => {
        // this.isSaverPlanBottomSheetShow = true;
        // this.saveDataInfoLocal();
      });
  }
}
